module.exports = __webpack_public_path__ + "img/Max_Demand_KWH.5d5a99dd.jpeg";